import React, { useState } from 'react';
import './App.css'

function App() {

  const [count1, setcount1] = useState(1);
  const [count2, setcount2] = useState(1);
  const [count3, setcount3] = useState(1);
  const [count4, setcount4] = useState(1);

  const valueChange = () => {
    console.log(this)
  }
  return (
    <React.Fragment>
      <section className="pageheadtitle">

        <div className="shop_cart">
          Shopping Cart
        </div>
        <div className="item">
          <a href="#">Home</a>
          / &nbsp;

          <a href="#" style={{ opacity: .5, pointerEvents: 'none' }} >
            Shopping Cart</a>
        </div>

      </section>

      <section className="listing_table">
        <div className="listing_table_title">
          <div className="item_wrapper">
            <span className="bag">
              Your Bag
          </span>
            <span>
              4 item
          </span>
          </div>
          <a href="#">Continue Shopping</a>
        </div>

        <div className="table_wrapper">
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Quality</th>
                <th>Total</th>
              </tr>

            </thead>

            <tbody>
              <tr>
                <td className="d-flex">

                  <img src="https://www.ncodetechnologies.com/miias/images/cart-wooden-chair-63x63.jpg" alt="" />

                  <div className="item">
                    <strong>Wooden Chair</strong> <br />
                    <small>
                      Size : M
                </small>
                    <br />
                    <small>
                      Color : White, Gold
                </small>
                  </div>
                </td>
                <td> <strong>
                  $98.00</strong></td>
                <td>  <span className="remove" onClick={() => setcount1((count1 > 1 )? count1 - 1 : 0)}>-</span><input onChange={valueChange} value={count1} type="text" /><span onClick={() => setcount1(count1 + 1)} className="add">+</span> </td>
                <td> <strong>{`$ ${count1 * 98}`}</strong></td>

              </tr>



              <tr>
                <td className="d-flex">
                  <img src="https://www.ncodetechnologies.com/miias/images/cart-lighting-vases-63x63.jpg" alt="" />
                  <div className="item">
                    <strong>Lighting Vases</strong> <br />

                    <small>
                      Size : M
</small>
                    <br />
                    <small>
                      Color : White, Gold
</small>
                  </div>
                </td>
                <td> <strong>
                  $98.00</strong></td>
                <td>  <span className="remove" onClick={() => setcount2(count2 > 1 ? count2 - 1 : 0)}>-</span><input onChange={valueChange} value={count2} type="text" /><span onClick={() => setcount2(count2 + 1)} className="add">+</span> </td>
                <td> <strong>{`$ ${count2 * 98}`}</strong></td>

              </tr>



              <tr>
                <td className="d-flex">
                  <img src="https://www.ncodetechnologies.com/miias/images/cart-teapot-ultimate-63x63.jpg" alt="" />
                  <div className="item">

                    <strong>Teapot Ultimate</strong> <br />

                    <small>
                      Size : M
</small>
                    <br />
                    <small>
                      Color : White, Gold
</small>
                  </div>
                </td>
                <td> <strong>
                  $98.00</strong></td>
                <td>  <span className="remove" onClick={() => setcount3(count3 > 1 ? count3 - 1 : 0)} setcount1>-</span><input onChange={valueChange} value={count3} type="text" /><span onClick={() => setcount3(count3 + 1)} className="add">+</span> </td>
                <td> <strong>{`$ ${count3 * 98}`}</strong></td>

              </tr>
              <tr>
                <td className="d-flex">

                  <img src="https://www.ncodetechnologies.com/miias/images/cart-vase-flower-63x63.jpg" alt="" />

                  <div className="item">

                    <strong>
                      Vase Flower</strong> <br />

                    <small>
                      Size : M
                </small>
                    <br />
                    <small>
                      Color : White, Gold
                </small>
                  </div>
                </td>
                <td> <strong>
                  $98.00</strong></td>
                <td>  <span className="remove" onClick={() => setcount4(count4 > 1 ? count4 - 1 : 0)}>-</span><input onChange={valueChange} value={count4} setcount1="text" /><span onClick={() => setcount4(count4 + 1)} className="add">+</span> </td>
                <td> <strong>{`$ ${count4 * 98}`}</strong></td>

              </tr>


            </tbody>
          </table>
        </div>
      </section>



    </React.Fragment>
  )
}

export default App;
